import { themeGet } from 'styled-system';
import styled, { css } from 'react-emotion';
import { Heading, Text, FlexCol, FlexRowCenter } from '../misc';

// @width
export const OuterWrapper = styled('div')`
  @media screen and (min-width: 52em) {
    width: 100%;
    position: relative;
    height: 100%;
    padding: ${themeGet('space.3')}px;
    border-right: 2px solid ${themeGet('colors.grey')};

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: ${themeGet('space.3')}px;
      background-color: ${themeGet('colors.grey')};
      z-index: 3;
    }
  }
`;

// TODO: refactor transition.
// @flex
// @overflow
// @padding
export const InnerWrapper = styled('div')`
  transition: initial;
  display: flex;
  flex-direction: column;
  align-items: start;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 1;
  transform: none;
  padding: ${themeGet('space.3')}px;
  pointer-events: auto;
  padding-bottom: 60px;
  overflow-y: scroll;
  -ms-overflow-style: none;
  background-color: ${themeGet('colors.greyLighter')};

  > div {
    flex-shrink: 0;
    flex-grow: 0;
  }
`;

// @padding
export const SearchResetOverlay = styled('div')`
  display: none;

  @media screen and (min-width: 52em) {
    display: block;
    position: absolute;
    background-color: transparent;
    left: 0;
    bottom: 20px;
    width: 100%;
    z-index: 5;
    padding: ${themeGet('space.4')}px;
  }
`;

export const ResponsiveFilterWrapper = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${props => (props.open ? '1' : '0')};
  pointer-events: ${props => (props.open ? 'auto' : 'none')};
  transform: translate(0px, ${props => (props.open ? '0px' : '40px')});
  transition: transform 0.5s ease, opacity 0.5s ease;
  padding: ${themeGet('space.3')}px;
  background-color: ${themeGet('colors.greyLighter')};
  overflow-y: scroll;
  z-index: 2;
`;

// @width
// @padding
export const ResponsiveHeaderRow = styled('div')`
  width: 50%;
  padding: ${themeGet('space.2')}px;
`;

export const IconClassName = css`
  margin-right: 25px;
  path {
    fill: #fff;
  }
`;

// @width
// @margin
// @flex
// @box-shadow
export const FilterSection = styled('div')`
  width: 100%;
  background-color: white;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: ${themeGet('space.3')}px;
  margin-bottom: ${themeGet('space.3')}px;
  box-shadow: 0 0.125rem 0.625rem 0 hsla(0, 0%, 80%, 0.5);
  overflow-x: hidden;
  opacity: ${props => (props.hide ? 0 : 1)};
`;

export const FilterHeading = styled(Heading)`
  font-size: 18px;
`;

export const FilterRowWrapper = styled(FlexCol)`
  display: ${props => (props.show ? 'flex' : 'none')};
  opacity: ${props => (props.show ? 1 : 0)};
  transform: ${props =>
    props.show ? 'translateY(15px)' : 'translateY(-15px)'};

  transition: all 0.25s ease;
`;

export const FilterRow = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${themeGet('space.3')}px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${themeGet('colors.greyLight')};
  }
`;

// @flex
export const FilterRowDescription = styled(Text)`
  flex: auto;
`;

export const FilterCountText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: ${themeGet('colors.black')};
`;

// @padding
export const FilterCount = styled('div')`
  padding: ${themeGet('space.1')}px ${themeGet('space.2')}px;
  min-width: 50px;
  border: 2px solid ${themeGet('colors.greyLight')};
  opacity: 0.8;
  text-align: center;
  border-radius: 4px;
`;

// @width
export const SliderWrapper = styled('div')`
  padding-top: 15px;
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  position: relative;
`;

// @width
// @flex
export const SliderHeading = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > span {
    font-weight: 300;
    font-size: 16px;
    color: ${themeGet('colors.blueDarker')};
  }
`;

// @width
export const RangeClassName = css`
  position: relative;
  padding-bottom: 24px;
  width: 100%;
`;

export const HandleStyle = {
  width: '24px',
  height: '24px',
  backgroundColor: '#fff',
  border: '.5px solid rgba(204, 0 , 0, 1)',
  boxShadow: '0 3px 3px 0 rgba(0,0,0,.05), 0 2px 2px 0 rgba(0,0,0,.1)',
  marginLeft: '-14px',
  marginTop: '-11px',
  position: 'absolute',
  borderRadius: '50%',
  touchAction: 'pan-x',
  cursor: 'pointer',
};

export const RailStyle = {
  backgroundColor: '#dae1e7',
  height: '2px',
  position: 'absolute',
  width: '100%',
};

// TODO: define colors
export const TrackStyle = disabled => ({
  height: '2px',
  backgroundColor: `${disabled ? '#dae1e7' : 'rgba(204, 0 , 0, 1)'}`,
  position: 'absolute',
});

// @flex
// @width
export const Item = styled('div')`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ItemTitle = styled('h3')``;

export const PriceHiderContainer = styled('div')`
  width: inherit;
  height: inherit;

  @media screen and (min-width: 64em) {
    transform: ${props =>
      props.showPrices ? 'translateY(0px)' : 'translateY(-109px)'};
  }
  opacity: ${props => (props.hasHits ? 1 : 0)};
  transition: ${props => (props.hasHits ? 'opacity 0.2s linear' : 'none')};
`;

export const SectionToggle = styled(FlexRowCenter)`
  flex: 0 0 50px;
  position: relative;
`;

export const RefinementCount = styled(FlexRowCenter)`
  position: absolute;
  width: 25px;
  height: 25px;
  right: 50px;
  border-radius: 50%;
  background-color: ${themeGet('colors.redLight')};
  font-size: 16px;
  color: #fff;
  opacity: ${props => (props.show ? 1 : 0)};
  transition: opacity 0.2s ease-in;
  top: -1px;
`;



// WEBPACK FOOTER //
// ./src/components/filter/style.js